import React from 'react';
import classNames from 'classnames';

const Input = props => {
  const {
    className,
    error,
    name,
    label,
    value,
    type,
    onChange,
    disabled,
  } = props;

  const classes = classNames('input-group', className, {
    error: error,
  });

  const inputClasses = classNames('input');

  return (
    <div className={classes}>
      {label && <label className="input-label">{label}</label>}
      <input
        name={name}
        type={type || 'text'}
        className={inputClasses}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default Input;
